import { TimerDisplay } from 'Components/common/Timer/TimerDisplay'
import styles from './TimerElement.module.less'
import { Timer } from 'Core/Timer'

type TimerPropsType = {
    getTimer: () => Timer
    handleTimerClick?: () => void
}

export const TimerElement = (props: TimerPropsType) => {
    return (
        <div className={styles.timerContainer}>
            {props.getTimer() && (
                <TimerDisplay timer={props.getTimer()} handleTimerClick={props.handleTimerClick} />
            )}
        </div>
    )
}
